
import { apiFetch } from './fetchApi'


export const updateJob = (BeURL, createJob, showAlert, isUpdate, id, options = {}, setLoading) => {
   const { access } = options;
   if (!access) {
      setLoading(true)
      const url = isUpdate ? `update-job/${id}` : 'update-job';
      apiFetch(`${BeURL}/${url}`, {
         method: 'PUT',
         body: JSON.stringify({ createJob }),
      })
         .then(res => res.json())
         .then(data => {
            if (data.success) {
               showAlert(data.message);
               window.location.href = "/list-jobs"
            } else {
               showAlert(data.message);
               setTimeout(() => {
                  if (data.isJobCreated && data.jobId) {
                     window.location.href = `/update-job/${data.jobId}`;
                  } 
               }, 2000);
            } 
         })
         .catch(err => {
            console.error("Error in create/update job:", err);
            alert("Error in create/update job");
         })
         .finally(() => {
            setLoading(false)
         })
   }
   else if (access === 'delete') {
      const url = `delete-job/${id}`;
      apiFetch(`${BeURL}/${url}`, {
         method: 'DELETE',
      })
         .then(res => res.json())
         .then(data => showAlert(data.message))
         .catch(err => {
            console.error("Error in deleting job:", err);
            alert("Error in deleting job");
         });
   }
};

export const reassignJob  = async(BeURL, showAlert,jobId,  payload) =>
{
   try{
      const accountRes = await apiFetch(`${BeURL}/update-reassignJob/${jobId}`, {
      method: "POST",
      body: JSON.stringify(payload),
   });

   const accountData = await accountRes.json()


   if (!accountData.success) {
      showAlert(accountData.message)
      return
   }


   showAlert(accountData.message);

   return true
   


} catch (err) {
   console.error("Error in Update Job  Reassign:", err)
   alert('Trouble connecting to the server! Please try again later.')
}
}
